/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext, useContext, ReactNode } from 'react';
import { useChatBase } from '../hooks/useChatBase';
import { ChatBase } from '../types/chatBase';

// Tipos para o contexto
interface ChatBaseContextType {
  // Estado
  chats: ChatBase[];
  selectedChatId: string | null;
  selectedChat: ChatBase | null;
  isLoadingChats: boolean;
  isCreatingChat: boolean;
  isSidebarOpen: boolean;
  error: string | null;
  
  // Ações
  loadChats: () => Promise<void>;
  createChat: (payload?: { title?: string }) => Promise<ChatBase | null>;
  selectChat: (chatId: string | null) => void;
  renameChat: (chatId: string, newTitle: string) => Promise<boolean>;
  archiveChat: (chatId: string) => Promise<boolean>;
  deleteChat: (chatId: string) => Promise<boolean>;
  toggleSidebar: () => void;
  getChatHistory: (chatId: string) => Promise<any>;
  clearHistoryCache: (chatId?: string) => void;
  updateHistoryCache: (chatId: string, newMessages: any[]) => void;
  updateChatMetadata: (chatId: string, newMessageCount?: number, lastMessage?: any) => void;
  addMessageToCache: (chatId: string, originalMessage: any) => void;
  
  // Utilitários
  hasChats: boolean;
  chatsCount: number;
}

// Criar o contexto
const ChatBaseContext = createContext<ChatBaseContextType | undefined>(undefined);

// Provider
interface ChatBaseProviderProps {
  children: ReactNode;
}

export function ChatBaseProvider({ children }: ChatBaseProviderProps) {
  const chatBaseHook = useChatBase();
  
  return (
    <ChatBaseContext.Provider value={chatBaseHook}>
      {children}
    </ChatBaseContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useChatBaseContext(): ChatBaseContextType {
  const context = useContext(ChatBaseContext);
  
  if (context === undefined) {
    throw new Error('useChatBaseContext must be used within a ChatBaseProvider');
  }
  
  return context;
}
